<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-23 15:29:58
 * @LastEditTime : 2020-01-07 18:21:11
 * @LastEditors  : Please set LastEditors
 -->
<!--  -->
<template>
  <div class="div_ucRoutePOISelect">
    <!-- <el-container > -->

    <el-collapse
      v-model="ucSetting.collapseModel"
      accordion
      @change="_routePOICollapseChangeHandler"
    >
      <el-collapse-item
        v-for="routePOIItem in routePOIs"
        :key="routePOIItem.id"
        :name="routePOIItem.id"
      >

        <!-- 标题模板-->
        <template slot="title">
          <i v-bind:class="{i_poi_unselected:!routePOIItem.selectStatus,i_poi_selected:routePOIItem.selectStatus}"></i>
          {{routePOIItem.description}}
        </template>

        <div>
          <UCSearchPOIResult
            ref="ucPOIResult"
            @event_UCSearchPOIResult_POIItemPickClick="_ucPOIResult_on_poiItemPickClickHandler"
          ></UCSearchPOIResult>

        </div>

      </el-collapse-item>

    </el-collapse>

    <!-- </el-container> -->

  </div>
</template>

<script>
import { RoutePOIInfo, UCRouteEvent } from "./UCRouteJs.js";
import UCSearchPOIResult from "./UCSearchPOIResult.vue";
import { POISearchFilterType, POISurroundType } from "../model/POISearch.js";

export default {
  name: "UCRoutePOISelect",

  props: {},

  data() {
    return {
      ucSetting: {
        //用于控制折叠面板开关
        collapseModel: null
      },

      callbacks: {
        poiSearchFinished: null
      },

      //搜索参数
      searchParams: null,

      // event_dd:UCRouteEvent.UCSearchPOIResult_POIItemPickClick,
      //地图筛选条件
      mapFilter: null,

      routePOIs: new Array()
    };
  },

  components: { UCSearchPOIResult },

  computed: {},

  mounted() {},

  methods: {
    init() {
      if (this.searchParams) {
        this.routePOIs = this.searchParams.getRoutePOIs();
      } else {
        this.routePOIs = new Array();
      }

      //   this._initEvent();
    },

    off_routePOIsSelectFinish(callback) {
      this.$off(UCRouteEvent.UCRoutePOISelect_selectFinish, callback);
    },

    on_routePOIsSelectFinish(callback) {
      this.$on(UCRouteEvent.UCRoutePOISelect_selectFinish, callback);
    },

    on_poiSearchFinished(callback) {
      if (callback) {
        this.callbacks.poiSearchFinished = callback;
      }
    },

    // _routePOICollapseItemClickHandler(routePOIItem, collapseIndex) {
    //   this._paginationCurrentChange(routePOIItem, 1);
    // },

    _routePOICollapseChangeHandler(activeName) {
      if (!activeName) return;

      let curPOIInfoIndex = RoutePOIInfo.findRoutePOIIndexById(
        this.routePOIs,
        activeName
      );

      let routePOICount = this.routePOIs.length;
      let curPOIInfo = this.routePOIs[curPOIInfoIndex];
      let curFilter = this.mapFilter.copy();
      curFilter.filterType = POISearchFilterType.national_purepoi;
      curFilter.keyWord = curPOIInfo.suggestKey;

      let poiSurroundType = null;
      if (curPOIInfoIndex === 0) {
        poiSurroundType = POISurroundType.type_route_startPOI;
      } else if (curPOIInfoIndex === routePOICount - 1) {
        poiSurroundType = POISurroundType.type_route_endPOI;
      } else {
        poiSurroundType = POISurroundType.type_route_viaPOI;
      }

      this.$refs.ucPOIResult[curPOIInfoIndex].routePOI = curPOIInfo;
      this.$refs.ucPOIResult[curPOIInfoIndex].curFilter = curFilter;
      this.$refs.ucPOIResult[curPOIInfoIndex].poiSurroundType = poiSurroundType;
      this.$refs.ucPOIResult[curPOIInfoIndex].off_poiSearchFinished(
        this.callbacks.poiSearchFinished
      );
      this.$refs.ucPOIResult[curPOIInfoIndex].on_poiSearchFinished(
        this.callbacks.poiSearchFinished
      );

      this.$refs.ucPOIResult[curPOIInfoIndex].init();
    },

    _ucPOIResult_on_poiItemPickClickHandler() {
      //折叠面板关闭
      this.ucSetting.collapseModel = null;

      let isIntegrity = this.searchParams.checkPOIIntegrity();
      if (isIntegrity) {
        this.$emit(
          UCRouteEvent.UCRoutePOISelect_selectFinish,
          this.searchParams
        );
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.div_ucRoutePOISelect {
  overflow-y: auto;

  padding: 5px 19px 5px 30px;
}

/deep/.el-collapse {
  border-top: none;
  border-bottom: none;

  .el-collapse-item {
    padding-bottom: 5px;

    .el-collapse-item__header {
      //修改高度为32
      height: 100%;
      line-height: 32px;

      //修改字体
      font-size: 12px;
      //修改颜色
      color: #000;

      background: #f2f8ff;

      .el-collapse-item__arrow {
        display: none;
      }
    }
  }
}

.i_poi_unselected {
  float: left;
  margin: 7px 10px;

  background: url("../../../assets/onlineMap/icon.png");
  background-repeat: no-repeat;
  // display: inline-block;
  width: 16px;
  height: 16px;
  background-position: -261px -184px;
}

.i_poi_selected {
  float: left;
  margin: 7px 10px;

  background: url("../../../assets/onlineMap/icon.png");
  background-repeat: no-repeat;
  // display: inline-block;
  width: 16px;
  height: 16px;

  background-position: -486px -154px;
}
</style>